import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { File } from '@ionic-native/file/ngx';
import { wrapAllMethodsWithLogging } from 'src/app/core/decorators/log-all-errors.decorator';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root'
})
export class FileSystemService {
  capturedImagePath: string;
  componentName: string = 'fileSystemService';

  constructor(public sanitizer: DomSanitizer, private _fileSystem: File,
    public loggingService: LoggingService
  ) {
    // wrapAllMethodsWithLogging(this, this.componentName);
  }
  async convertBase64ToJpg(base64Path) {
    var realData = base64Path.split(",")[1];
    let blob = await this.b64toBlob(realData, 'image/jpeg');
    var imageName;
    const today = new Date();
    if (blob.type == 'image/jpeg') {
      imageName = "web_" + today.getTime().toString() + '.jpg';
    }
    return { fileName: imageName, file: blob }
  }

  async b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  async Blobtob64(blob) {
    const blobToBase64 = blob => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      return new Promise(resolve => {
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
    };
  }


  convertToBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    });
  }


  fileToDataURL(file: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }

  async convertUrlToBase64(url: string): Promise<string> {
    try {
      const response = await fetch(url);
      const blob = await response.blob();

      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

    } catch (error) {
      console.error('Base64 conversion failed', error);
      throw error;
    }
  }

  convertblobtoURL(file) {
    var blob = new Blob([file], { type: 'image/jpeg' });
    const unsafeImg = URL.createObjectURL(blob);
    return this.sanitizer.bypassSecurityTrustUrl(unsafeImg);
  }

  convertFileToURL(file: any) {
    const blob = new Blob([file], { type: file.type });
    const unsafeUrl = URL.createObjectURL(blob);
    return unsafeUrl;
    // return this.sanitizer.bypassSecurityTrustUrl(unsafeUrl);
  }

  async writeFileFromBlob(fileName, blob, subDirectory = null) {
    var fileStorePath = this.getFileSystemUrl();
    if (subDirectory) {
      fileStorePath = this.getFileSystemUrl() + subDirectory;
    }
    return await this._fileSystem.writeFile(fileStorePath, fileName, blob);
  }

  getFileSystemUrl() {
    return this._fileSystem.externalDataDirectory;
  }
}
